import { FooterI18n } from '@/locales/base.message.locales';

export const footer: FooterI18n = {
  contact: 'Contact Us',
  privacy_policy: 'Privacy Policy',
  terms: 'Terms & Conditions',
  inspiring: {
    ayrton_senna: {
      quote: 'If you want to be successful you need total dedication, seek your last limit and give the best of yourself.',
      author: 'Ayrton Senna'
    },
    c_s_lewis: {
      quote: 'Difficulties prepare ordinary people for extraordinary destinations.',
      author: 'C.S Lewis'
    },
    dalai_lama: {
      quote: 'There are only two days of the year when you can\'t do anything: one is called yesterday and the other is called tomorrow.',
      author: 'Dalai Lama'
    },
    confucio: {
      quote: 'No matter how fast you walk, but the willpower to never stop.',
      author: 'Confúcio'
    },
    muhammad_ali: {
      quote: 'To be a champion you have to believe in yourself when nobody else does.',
      author: 'Muhammad Ali'
    },
    theodore_roosevelt: {
      quote: 'Do what you can, with what you have, wherever you are.',
      author: 'Theodore Roosevelt'
    },
    fernando_sabino: {
      quote: 'In the end everything works out, and if it didn\'t work out, it\'s not over yet.',
      author: 'Fernando Sabino'
    },
    aristoteles: {
      quote: 'There is only one way to avoid criticism: not doing, not talking and being nothing.',
      author: 'Aristóteles'
    },
    winston_churchill: {
      quote: 'The pessimist sees difficulty at every opportunity. The optimist sees opportunity in every difficulty.',
      author: 'Winston Churchill'
    },
    frida_kahlo: {
      quote: 'At the end of the day, we can take much more than we think we can.',
      author: 'Frida Kahlo'
    },
    michelle_obama: {
      quote: 'Success is not about where you came from, but about the confidence you have and the effort you are willing to invest.',
      author: 'Michelle Obama'
    },
    michael_jordan: {
      quote: 'I can accept failure, everyone fails at something. But I can\'t accept not trying.',
      author: 'Michael Jordan'
    },
    albert_einstein: {
      quote: 'Strive not to be a success, but to be valuable.',
      author: 'Albert Einstein'
    },
    stephen_hawking: {
      quote: 'Intelligence is the ability to adapt to changes.',
      author: 'Stephen Hawking'
    },
    bill_gates_one: {
      quote: 'Patience is a fundamental element of success.',
      author: 'Bill Gates'
    },
    napoleao_bonaparte: {
      quote: 'The art of being audacious, sometimes prudent, is the art of winning.',
      author: 'Napoleao Bonaparte'
    },
    henry_ford_one: {
      quote: 'Our failures are sometimes more fruitful than successes.',
      author: 'Henry Ford'
    },
    santo_agostinho: {
      quote: 'Even if you have already gone a long way, there is always a new way to go.',
      author: 'Santo Agostinho'
    },
    oscar_wilde: {
      quote: 'Experience is the name that everyone gives to their mistakes.',
      author: 'Oscar Wilde'
    },
    john_f_kennedy: {
      quote: 'Only those who dare to make a lot of mistakes can accomplish a lot.',
      author: 'J ohn F Kennedy'
    },
    bill_gates_two: {
      quote: 'Every company needs to have people who make mistakes, who are not afraid of making mistakes and who learn from mistakes.',
      author: 'Bill Gates Two'
    },
    henry_ford_two: {
      quote: 'People don\'t fail. Simply give up.',
      author: 'Henry Ford'
    },
    walt_disney: {
      quote: 'If you can dream, you can accomplish.',
      author: 'Walt Disney'
    },
    martin_luther_king: {
      quote: 'The time is always right to do the right thing',
      author: 'Martin Luther King'
    },
  }
};
